
import Vue from 'vue';
import EventService from '@/services/EventService';
import {mapState} from 'vuex';
import store from '../store';

const baseURL = EventService.ProtoURL();
import axios from 'axios';
const apiClient = axios.create({
  baseURL: baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(config => {
  const companyID = store.state.current;
  if (companyID !== '') {
    config.headers['x-company-id'] = companyID;
  }
  return config;
});

type FormRule = (val?: string) => boolean | string;

type Data = {
  loaded: boolean;
  items: Array<string>;
  placeRule: Array<FormRule>;
};

type CompnayAddress = {
  address: string;
};

export default Vue.extend({
  name: 'audit-history-address',
  computed: {
    ...mapState(['user']),
  },
  props: {
    address: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  updated() {
    this.$emit('loaded-address');
  },
  data: (): Data => ({
    loaded: true,
    items: [],
    placeRule: [(val?: string) => !!val || '開催場所を入力してください'],
  }),
  async mounted() {
    if (this.user) {
      const token = await this.user.getIdToken();
      const {data} = await apiClient.get('/histories/address', {
        headers: {Authorization: `Bearer ${token}`},
      });
      // console.log(data);
      this.items.push(data.address);
      this.loaded = false;
    }
  },
});
